import { Component, Input } from '@angular/core';
import { IDocumentResult } from '../../state/interfaces';
import { MatCard, MatCardContent } from '@angular/material/card';

import { MatIcon } from '@angular/material/icon';
import { MatList, MatListItem, MatListItemIcon, MatListItemLine } from '@angular/material/list';

@Component({
  selector: 'eca-results-list',
  templateUrl: './results-list.component.html',
  styleUrls: ['./results-list.component.scss'],
  imports: [MatCard, MatCardContent, MatIcon, MatList, MatListItem, MatListItemIcon, MatListItemLine]
})
export class ResultsListComponent {

  @Input() isDoneProcessingScans: boolean;
  @Input() successful: IDocumentResult[] = [];
  @Input() failures: IDocumentResult[] = [];
  @Input() processing: IDocumentResult[] = [];

  constructor() {}
}

